/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_No_PlayersInputs */

const th_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีผู้เล่น`)
};

const en_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No players.`)
};

const ja_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選手がいません。`)
};

const zh_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无球员。`)
};

const es_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin jugadores.`)
};

const pt_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogador.`)
};

const id_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pemain.`)
};

const fr_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun joueur.`)
};

const tl_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang manlalaro.`)
};

const vi_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có cầu thủ.`)
};

const ko_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수가 없습니다.`)
};

const de_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Spieler.`)
};

const ru_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игроков нет.`)
};

const tr_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyuncu yok.`)
};

const it_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun giocatore.`)
};

const pl_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak zawodników.`)
};

const uk_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гравців немає.`)
};

const hi_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई खिलाड़ी नहीं।`)
};

const ar_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد لاعبون.`)
};

const ms_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada pemain.`)
};

const bn_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনও খেলোয়াড় নেই।`)
};

const zh_tw2_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有球員。`)
};

const zh_hk2_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有球員。`)
};

const ur_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی کھلاڑی نہیں۔`)
};

const fa_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازیکنی نیست.`)
};

const sw_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna wachezaji.`)
};

const nl_admin_no_players = /** @type {(inputs: Admin_No_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen spelers.`)
};

/**
* | output |
* | --- |
* | "No players." |
*
* @param {Admin_No_PlayersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_no_players = /** @type {((inputs?: Admin_No_PlayersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_No_PlayersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_no_players(inputs)
	if (locale === "ja") return ja_admin_no_players(inputs)
	if (locale === "zh") return zh_admin_no_players(inputs)
	if (locale === "es") return es_admin_no_players(inputs)
	if (locale === "pt") return pt_admin_no_players(inputs)
	if (locale === "id") return id_admin_no_players(inputs)
	if (locale === "fr") return fr_admin_no_players(inputs)
	if (locale === "tl") return tl_admin_no_players(inputs)
	if (locale === "vi") return vi_admin_no_players(inputs)
	if (locale === "ko") return ko_admin_no_players(inputs)
	if (locale === "de") return de_admin_no_players(inputs)
	if (locale === "ru") return ru_admin_no_players(inputs)
	if (locale === "tr") return tr_admin_no_players(inputs)
	if (locale === "it") return it_admin_no_players(inputs)
	if (locale === "pl") return pl_admin_no_players(inputs)
	if (locale === "uk") return uk_admin_no_players(inputs)
	if (locale === "hi") return hi_admin_no_players(inputs)
	if (locale === "ar") return ar_admin_no_players(inputs)
	if (locale === "ms") return ms_admin_no_players(inputs)
	if (locale === "bn") return bn_admin_no_players(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_no_players(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_no_players(inputs)
	if (locale === "ur") return ur_admin_no_players(inputs)
	if (locale === "fa") return fa_admin_no_players(inputs)
	if (locale === "sw") return sw_admin_no_players(inputs)
	if (locale === "nl") return nl_admin_no_players(inputs)
	return en_admin_no_players(inputs)
});